module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', _vm._l((_vm.logosList), function(logo) {
    return _c('li', {
      key: logo.url
    }, [(logo.link) ? _c('a', {
      attrs: {
        "href": logo.link,
        "target": "_blank"
      }
    }, [(logo.imgUrl) ? _c('img', {
      attrs: {
        "src": logo.imgUrl,
        "width": logo.size.width,
        "height": logo.size.height
      }
    }) : _vm._e(), _vm._v(" "), (logo.text) ? _c('span', [_vm._v(_vm._s(logo.text))]) : _vm._e()]) : [(logo.imgUrl) ? _c('img', {
      attrs: {
        "src": logo.imgUrl,
        "width": logo.size.width,
        "height": logo.size.height
      }
    }) : _vm._e(), _vm._v(" "), (logo.text) ? _c('span', [_vm._v(_vm._s(logo.text))]) : _vm._e()]], 2)
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-892a263e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Logos.vue
// module id = 624
// module chunks = 2